import { RadioGroup, FormControlLabel, TextField, Select, FormGroup, Checkbox, Radio } from '@material-ui/core';
import styled, { css } from 'styled-components';
import { defaultMuiTheme } from '../../../../styles/MaterialTheme';
export const QuestionText = styled.h3 `
    font-weight: 600;
    font-size: ${(props) => props.theme.fonts.textSizeH3};
    margin-bottom: 0.5rem;
    white-space: pre-line;
`;
const SharedFormGroupStyles = css `
    > label {
        margin-bottom: 0.5rem;

        &:last-child {
            margin-bottom: 0;
        }
    }
`;
export const StyledFormGroup = styled(FormGroup) `
    ${SharedFormGroupStyles};
`;
export const StyledRadioGroup = styled(RadioGroup) `
    ${SharedFormGroupStyles};

    .Mui-checked.Mui-disabled {
        color: ${(props) => props.theme.colors.selectedActionDisabled};
    }

    .MuiTypography-root.Mui-disabled {
        color: ${(props) => props.theme.colors.text};
    }
`;
const SharedControlStyles = css `
    /* aligns checkbox rather than edge of transparent button */
    ${defaultMuiTheme.breakpoints.down('xs')} {
        margin-top: -7px;
    }
`;
export const StyledCheckbox = styled(Checkbox) `
    ${SharedControlStyles};
`;
export const StyledRadio = styled(Radio) `
    ${SharedControlStyles};
`;
const SharedFormControlLabelStyles = css `
    ${defaultMuiTheme.breakpoints.down('xs')} {
        display: flex;
        align-items: flex-start;
    }
`;
export const StyledRadioFormControlLabel = styled(FormControlLabel) `
    ${SharedFormControlLabelStyles};
`;
export const StyledFormControlLabel = styled(FormControlLabel) `
    ${SharedFormControlLabelStyles};

    .Mui-checked.Mui-disabled {
        color: ${(props) => props.theme.colors.selectedActionDisabled};
    }

    .MuiTypography-root.Mui-disabled {
        color: ${(props) => props.theme.colors.text};
    }
`;
export const StyledTextField = styled(TextField) `
    .Mui-disabled {
        color: ${(props) => props.theme.colors.text};
    }
`;
export const StyledSelect = styled(Select) `
    .Mui-disabled {
        color: ${(props) => props.theme.colors.text};
    }
`;
//# sourceMappingURL=QuestionViewer.styles.js.map